import React, { useState } from "react";
import Box from "@mui/material/Box";
import Audience from "./Audience";
import Segments from "../Segment/Segments";
import CustomTabs from "../../common/custom-tabs";

// Combines two previously-separate menu items (Audience, Segments) into one
// page with tabs. Each tab's visibility is still gated by its own original
// permission -- no change to who can see what, just where it's reachable
// from. Structure mirrors Logs/Logs.jsx (LogsDashboard) for consistency.
const BroadcastAudienceTab = (props) => {
  const permissionsFromStorage = JSON.parse(localStorage.getItem("permissions") || "[]");
  const hasAudience = permissionsFromStorage.includes("audience.view");
  const hasSegment = permissionsFromStorage.includes("segment.view");

  const allTabs = [
    { label: "Audience", value: 0, show: hasAudience },
    { label: "Segment", value: 1, show: hasSegment },
  ];
  const tabs = allTabs.filter((tab) => tab.show !== false);

  const requestedTab = props.pageParams?.tab;
  const initialTab = tabs.some((tab) => tab.value === requestedTab)
    ? requestedTab
    : tabs[0]?.value ?? 0;
  const [currentTab, setCurrentTab] = useState(initialTab);

  const handleTabsChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          pt: 5,
          px: 3,
          backgroundColor: "#F7F7F7",
        }}
      >
        <Box sx={{ mb: 2 }}>
          <CustomTabs
            value={currentTab}
            onChange={handleTabsChange}
            tabs={tabs}
            inactiveBgColor="#E8EAED"
            backgroundColor="#E8EAED"
          />
        </Box>

        {currentTab === 0 && hasAudience && <Audience {...props} />}
        {currentTab === 1 && hasSegment && <Segments {...props} />}
      </Box>
    </div>
  );
};

export default BroadcastAudienceTab;
